import React from 'react';

import SkillDevelopmentItem from './SkillDevelopmentItem.js';

export default function ({skill_data}) {

    const skill_items = skill_data.map((skill_item, key) => {
        return (
            <SkillDevelopmentItem
                key={key}
                skill_item={skill_item}
                skill_low_percentage={skill_data[0].achievement_percentage}
            />
        );
    });

    return (
        <div className="tsp-development-skill flex-column flex-between">
            <div className="development-skill-name">
                {skill_data[0].practice_skill_name}
            </div>

            <div className="flex-row">
                {skill_items}
            </div>
        </div>
    );
}